import script from "./FloatingCart.vue?vue&type=script&setup=true&lang=ts"
export * from "./FloatingCart.vue?vue&type=script&setup=true&lang=ts"

import "./FloatingCart.vue?vue&type=style&index=0&id=71c93717&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71c93717"]])

export default __exports__